<template>
    <div v-if="show">
        <hp5-tooltip
        tooltip-id="button-2"
        tooltip-position="top"
        trigger-element-id="example2"
      >
        <button
          aria-describedby="button-2"
          id="example2"
          slot="trigger"
          type="button"
        >
          Good value
        </button>
        <div slot="content" v-if="showForLowCostAndHighQuality">
          This most relevant result is a low-cost, high-quality doctor and location relative to the ZIP code you entered        </div>
        <div slot="content" v-if="showForLowCostAndQuality">
          This most relevant result is a low-cost doctor and location relative to the ZIP code you entered        </div>
      </hp5-tooltip>
    </div>
</template>

<script setup>
    const props = defineProps({
        result: Object
    })
    const showForLowCostAndHighQuality = computed(() =>  props.result && props.result.costRating && props.result.costRating.value && props.result.costRating.value == 1 && props.result.qualityRating && props.result.qualityRating.value && props.result.qualityRating.value == 4)
    const showForLowCostAndQuality = computed(() =>  props.result && props.result.costRating && props.result.costRating.value && props.result.costRating.value == 1 && props.result.qualityRating && (props.result.qualityRating.value && props.result.qualityRating.value !== 4 ||  props.result.qualityRating.value == null)) 
    const show = computed(() => showForLowCostAndHighQuality.value || showForLowCostAndQuality.value)
</script>

<style lang="scss" scoped>

</style>